import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

interface SelectedItem {
  orderId: number;
  obtainId: number;
}

// recoilPersist 설정
const { persistAtom } = recoilPersist({
  key: 'recoil-persist', // LocalStorage에 저장될 key
  storage: sessionStorage, // 저장 방식: localStorage
});

// Order ID를 저장하는 atom 정의
export const orderIdState = atom<number | null>({
  key: 'orderIdState', // 각 atom의 고유한 ID (key)
  default: null, // 기본값 설정
  effects_UNSTABLE: [persistAtom], // Recoil Persist를 통해 localStorage에 상태를 저장
});

// 선택된 아이템들을 저장하는 atom 정의
export const selectedItemsState = atom<SelectedItem[]>({
  key: 'selectedItemsState', // 고유한 key
  default: [], // 기본값 설정
  effects_UNSTABLE: [persistAtom], // Recoil Persist를 통해 localStorage에 상태를 저장
});
